class SizeGuideDrawer extends Drawer {
    constructor() {
        super();
    }

    connectedCallback() {
        document.querySelectorAll('[data-size-guide]').forEach((el) => {
            el.addEventListener('click', (event) => {
                event.preventDefault();
                this.open();
            });
        });
    }
}

if (!customElements.get('size-guide-drawer')) {
    customElements.define('size-guide-drawer', SizeGuideDrawer);
}